module.exports = __webpack_public_path__ + "45d7016c0122d2979a16b576f6c4a598.pdf";